import { useEffect } from 'react';

export function useScrollRestore(loading) {
  useEffect(() => {
    if (loading) return;
    const id = sessionStorage.getItem('scrollToVehicle');
    if (!id) return;
    sessionStorage.removeItem('scrollToVehicle');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const el = document.getElementById(`vehicle-${id}`);
        if (el) el.scrollIntoView({ block: 'center' });
      });
    });
  }, [loading]);
}
